import React from "react";
import {
  RaisedButton,
  TextField,
  SelectField,
  MenuItem,
  Checkbox
} from "material-ui";

import OrderableTextFieldList from "./orderable-text-field-list.jsx";

const FIELD_TYPES = [
  ["string", "Text"],
  ["address", "Mailing address"],
  ["phone", "Phone number"],
  ["date", "Date"],
  ["select", "Dropdown select"],
  ["checkbox", "Checkbox"],
  ["state", "State (US)"],
  ["image", "Image upload"]
];

class SupplementaryDataEditorField extends React.Component {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.delete = this.delete.bind(this);
    this.shift = this.shift.bind(this);
    this._makeCheckbox = this._makeCheckbox.bind(this);
    this._makeTextField = this._makeTextField.bind(this);
  }

  getStyles() {
    return {
      container: {
        border: "1px solid #ccc",
        padding: "0 20px 20px",
        marginBottom: 10
      },
      actionsContainer: {
        float: "right",
        marginTop: 16,
        display: "flex",
        alignItems: "center"
        // marginTop: 10
      }
    };
  }

  changeType(type) {
    this.update({
      type: type,
      label: this.props.field.label || FIELD_TYPES.find(f => f[0] === type)[1] // inject label if none set already
    });
  }

  update(data) {
    // Extend, don't overwrite
    this.props.update(Object.assign({}, this.props.field, data));
  }

  delete() {
    if (
      window.confirm(
        "Are you sure? Any existing responses to this question will be deleted."
      )
    ) {
      this.props.update(null);
    }
  }

  shift(dir) {
    this.props.shiftPosition(dir);
  }

  _makeCheckbox(label, fieldKey, opts) {
    let { field } = this.props;

    return (
      <div key={`checkbox-${fieldKey}`} style={{ width: 400 }}>
        <Checkbox
          label={label}
          checked={field[fieldKey]}
          onCheck={e => this.update({ [fieldKey]: !field[fieldKey] })}
          {...opts}
        />
      </div>
    );
  }

  _makeTextField(label, fieldKey, opts) {
    let { field } = this.props;

    return (
      <div key={`textfield-${fieldKey}`}>
        <TextField
          floatingLabelText={label}
          floatingLabelFixed={true}
          value={field[fieldKey]}
          fullWidth={true}
          onChange={e => this.update({ [fieldKey]: e.target.value })}
          {...opts}
        />
      </div>
    );
  }

  render() {
    let styles = this.getStyles(),
      { field } = this.props;

    let additional = [];

    if (field.type === "string") {
      additional.push(this._makeCheckbox("Multiline", "multiline"));
    }

    if (field.type === "checkbox") {
      additional.push(
        this._makeTextField(
          "Checkbox label (displayed directly next to the ☑)",
          "checkbox_label"
        )
      );
    }

    if (field.type === "state") {
      additional.push(
        this._makeCheckbox(
          'Show "I don\'t live in the United States" option',
          "show_none_option"
        )
      );
      if (field.show_none_option) {
        field.none_option_text =
          field.none_option_text || "I don't live in the United States";
        additional.push(
          this._makeTextField(
            "Alternative text for non-US option",
            "none_option_text"
          )
        );
      }
    }

    if (field.type === "select") {
      additional.push(
        this._makeCheckbox("Allow multiple selections", "multiple")
      );
      additional.push(
        <OrderableTextFieldList
          label="Options"
          addLabel="Add option"
          fields={field.options}
          onChange={values => this.update({ options: values })}
        />
      );
    }

    if (field.type === "image") {
      additional.push(
        this._makeCheckbox("Square (1:1 aspect ratio)", "square")
      );
    }

    return (
      <div style={styles.container}>
        <div style={styles.actionsContainer}>
          <h3 style={{ marginRight: 7 }}>{`Field #${this.props.index}`}</h3>
          <RaisedButton label="Delete" onTouchTap={this.delete} />
          <RaisedButton
            label="▲"
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftUp}
            onTouchTap={() => this.shift(-1)}
          />
          <RaisedButton
            label="▼"
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftDown}
            onTouchTap={() => this.shift(1)}
          />
        </div>
        <div>
          <SelectField
            value={field.type}
            floatingLabelText="Type"
            onChange={(e, key, value) => this.changeType(value)}
          >
            {FIELD_TYPES.map(t => (
              <MenuItem value={t[0]} primaryText={t[1]} />
            ))}
          </SelectField>
        </div>
        {/* not revealed to user - hidden in background
        this._makeTextField('Key (column name in tables/etc.)', 'key') */}
        {this._makeTextField("Label", "label")}
        {this._makeTextField("Description", "description", {
          multiLine: true,
          style: { marginBottom: 10 }
        })}
        {this._makeCheckbox("Required", "required")}
        {this._makeCheckbox("Hidden from customer", "hidden")}
        {additional}
      </div>
    );
  }
}

export default SupplementaryDataEditorField;



// WEBPACK FOOTER //
// ./src/app/components/partials/supplementary-data-editor-field.jsx